import { Navigate } from 'react-router';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Route guard for Templates / Designer (the "canvas" surfaces: `/app/templateManagement`,
 * `/app/designManagement`).
 *
 * On a white-label / custom domain, Branding Settings → "Enable Templates & Designer" maps to
 * `brandingData.customBrandCanvas`. When it is unchecked (`=== false`), Templates/Designer is already
 * hidden from every nav + Create menu (TopNavigation, AssetsPage, AssetSidebar, the Playlists New
 * dropdown) — but that alone leaves the pages reachable by pasting the URL directly. This guard closes
 * that hole by redirecting to Screens.
 *
 * Default is ENABLED: `customBrandCanvas` defaults to `true` and is `undefined` for non-branded
 * accounts, so only an explicit `false` blocks. Wrap OUTSIDE any role gate (RestrictedRoute /
 * DesignerPermissionGate) so the branding block applies regardless of role.
 */
export function CanvasEnabledRoute({ children }: { children: React.ReactNode }) {
  const me = useAuthStore((s) => s.me);
  const customBrandCanvas = useAuthStore((s) => s.company?.brandingData?.customBrandCanvas);

  // While auth/company is still loading, don't flash a redirect (ProtectedRoute handles auth loading).
  if (!me) return null;

  if (customBrandCanvas === false) {
    return <Navigate to="/app/screenManagement" replace />;
  }

  return <>{children}</>;
}
